<template>
    <div class="container-fluid">
        <div class="row mt-3">
            <div
                class="col-sm-12"
                style="padding-top: 50px; padding-bottom: 100px;"
                name="shippingOptionsTable"
                v-if="
                    (getShippingOptions.products !== undefined &&
                        getShippingOptions.products.length > 0) ||
                        (getShippingOptions.quoteProducts !== undefined &&
                            getShippingOptions.quoteProducts.length > 0)
                "
            >
                <b-row class="headers">
                    <b-col>{{ $t('createShipment.label.product') }}</b-col>
                    <b-col>{{ $t('createShipment.label.transportProduct') }}</b-col>
                    <b-col>{{ $t('createShipment.label.billableWeight') }}</b-col>
                    <b-col
                        cols="2"
                    >{{ $t('createShipment.label.servicePoints') }}</b-col>
                    <b-col cols="2">{{ $t('createShipment.label.services') }}</b-col>
                    <b-col
                        v-if="display(fieldNames.PRICE)"
                        name="TotalSalesPrice"
                    >{{ $t('createShipment.label.price') }}</b-col>
                    <b-col
                        v-if="display(fieldNames.TRANSIT_TIME)"
                        name="EstimatedTransitTime"
                    >{{ $t('createShipment.label.estimatedTransitTime') }}</b-col>
                    <b-col>{{ $t('createShipment.label.select') }}</b-col>
                </b-row>

                <b-row
                    class="rows borders"
                    v-bind:key="item.salesProductId"
                    v-for="(item, index) in fetchedProducts"
                >
                    <b-col id="leftBorder">{{ item.salesProductName }}</b-col>
                    <b-col>{{ item.transportProductName }}</b-col>
                    <b-col>{{ item.billableWeight }}</b-col>

                    <b-col cols="2">
                        <div v-if="item.servicePoints.length > 0">
                            <vSelect
                                :dynamicWidth="false"
                                id="servicePoints"
                                :options="item.servicePoints"
                                :reduce="(p) => p.key"
                                label="description"
                                :placeholder="$t('createShipment.placeholder.Choose Pickup')"
                                :name="'ServicePoints_' + index"
                                v-model="item.selectedServicePoint"
                                :clearable="false"
                                class="service-point-dropdown"
                            />
                        </div>
                    </b-col>
                    <b-col cols="2">
                        <servicePrice
                            :get-shipment-price="getShipmentPrice"
                            :servicegroups="item.productServiceGroups"
                            :originalprice="item.priceLines"
                            :index="index"
                            :product="item"
                            @setSelectedProduct="selectSalesProduct(item)"
                        ></servicePrice>
                    </b-col>

                    <b-col
                        :name="'TotalSalesPrice_' + index"
                        class="price-accordion"
                        v-if="display(fieldNames.PRICE)"
                    >
                        <b-col
                            class="price-accordion-total-price"
                            v-b-toggle="'price-accordion-' + index"
                            @click="rotateIcon(index)"
                            :name="'TotalSalesPriceToggle_' + index"
                        >
                            <font-awesome-icon
                                icon="caret-right"
                                size="sm"
                                :rotation="item.priceExpanded ? '90' : null"
                            />
                            {{ localizedNumber(getTotalPrice(item.priceLines)) }}
                        </b-col>

                        <b-col class="price-accordion">
                            <b-collapse :id="'price-accordion-' + index">
                                <p
                                    class="price-expanded"
                                    v-for="(priceItem, priceIndex) in item.priceLines"
                                    v-bind:key="priceItem.text"
                                    :name="'Priceline_' + index + '_' + priceIndex"
                                >{{ priceItem.text }}: {{ localizedNumber(priceItem.value) }}</p>
                            </b-collapse>
                        </b-col>
                    </b-col>

                    <b-col
                        :name="'EstimatedTransitTime_' + index"
                        v-if="display(fieldNames.TRANSIT_TIME)"
                    >
                        <font-awesome-icon
                            icon="spinner"
                            size="lg"
                            spin
                            v-if="item.estimatedTransitTime === ''"
                        />
                        <span v-else>{{ item.estimatedTransitTime }}</span>
                    </b-col>

                    <b-col>
                        <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="item.selected"
                            @change="selectSalesProduct(item)"
                            :name="'SelectedSalesProduct_' + index"
                        />
                    </b-col>
                </b-row>

                <quoteProductRow
                    v-bind:key="item.transportProductId"
                    v-for="item in fetchedQuoteProducts"
                    :quoteProduct="item"
                    :shippingOptions="getShippingOptions"
                    @display-request-quote="$emit('display-request-quote', $event)"
                />

                <div class="create-shipment-buttons">
                    <b-row v-if="display(fieldNames.TRANSIT_TIME)">
                        <b-col
                            name="transitTimeInfo"
                        >{{ $t('createShipment.info.transitTime') }}</b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-button-group
                                class="create-shipment-buttons"
                                v-if="selectedProduct != null"
                            >
                                <b-button
                                    size="sm"
                                    @click="$emit('create-shipment', selectedProduct)"
                                    name="createShipmentButton"
                                >{{ $t('createShipment.button.createShipment') }}</b-button>

                                <b-button
                                    v-if="display(fieldNames.PRE_BOOKING)"
                                    size="sm"
                                    class="ml-3"
                                    @click="$emit('create-prebooking', selectedProduct)"
                                    name="createPreBookingButton"
                                >{{ $t('createShipment.button.preBooking') }}</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { EventBus } from '@/services/event-bus.js';
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
  import { mapState, mapGetters } from 'vuex';
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import viewOptions from '../mixins/viewOptionsMixin';
  import localization from '../mixins/localizationMixin';
  import validationSummary from '../mixins/validationSummary';
  import { FIELD_NAMES, EVENTS, BOOKING_TYPES } from '../store/nameConstants';
  import servicePrice from './servicePrice';
  import quoteProductRow from './quoteProduct';
  import shippingOptionsCards from './shippingOptionsCards';

  export default {
      props: {
          getShipmentPrice: { type: Function, required: true },
          v: { required: true },
      },
      components: {
          vSelect,
          servicePrice,
          quoteProductRow,
          shippingOptionsCards,
      },
      mixins: [viewOptions, localization, validationSummary],
      watch: {
          'shipment.shipDate': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
      },
      data() {
          return {
              servicePoint: null,
              fieldNames: FIELD_NAMES,
              products: [],
              quoteProducts: [],
              selectedProduct: null,
              selectedService: null,
              currentPriceLine: null,
              errorBookingListenerAdded: false,
              errorBookingPending: false,
              validationErrorPending: false,
              productChange: new Date(),
          };
      },

      methods: {
          getTotalPrice(priceLines) {
              let totalPrice = 0;

              priceLines.forEach((element) => (totalPrice += element.value));

              return totalPrice;
          },
          selectSalesProduct(product) {
              if (product.selected) {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX +
                          ACTIONS.CREATESHIPMENT.CLEAR_SELECT_SHIPPING_OPTION_PRODUCT //sætter alle produkter til selected = false
                  );

                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SELECT_SHIPPING_OPTION_PRODUCT,
                      {
                          salesProductId: product.salesProductId,
                          transportProductId: product.transportProductId,
                      }
                  );

                  this.selectedProduct = product;
              } else {
                  this.selectedProduct = null;
              }
          },

          rotateIcon(index) {
              this.products[index].priceExpanded === false
                  ? this.$store.dispatch(
                        CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_PRICE_EXPANDED,
                        { index: index, priceExpanded: true }
                    )
                  : this.$store.dispatch(
                        CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_PRICE_EXPANDED,
                        { index: index, priceExpanded: false }
                    );

              this.productChange = new Date(); //To trigger computed property is being called
          },
      },
      computed: {
          ...mapGetters('createShipment', [
              'getShippingOptions',
              'getBackendErrors',
              'getServicePrices',
          ]),

          fetchedProducts() {
              if (this.productChange) {
                  this.products = this.getShippingOptions.products;
              }

              return this.products;
          },
          fetchedQuoteProducts() {
              if (this.productChange) {
                  this.quoteProducts = this.getShippingOptions.quoteProducts;
              }

              return this.quoteProducts;
          },
      },
  };
</script>

<style>
  .headers {
      font-weight: bold;
      padding: 12px;
      border: solid 1px #1f7037;
      background: #1f7037;
      color: #eeeeee;
  }

  .borders div {
      border-right: solid 1px #1f7037;
      border-bottom: solid 1px #1f7037;
      padding: 4px;
  }

  .create-shipment-buttons {
      padding-top: 15px;
      float: left;
  }

  #leftBorder {
      border-left: solid 1px #1f7037;
  }

  #services {
      padding-left: 25px;
  }

  #servicePoints {
      background: none;
      border: 1px solid rgba(60, 60, 60, 0.26);
      border-radius: 4px;
      white-space: normal;
      padding: 0px;
  }

  .price-accordion-total-price {
      float: left;
      cursor: pointer !important;
  }

  .price-accordion {
      float: left;
      text-align: left;
      padding: 0px;
  }

  .price-expanded {
      margin-bottom: 0px;
  }

  .borders div > div {
      border: 0;
  }

  .service-point-dropdown div div span {
      width: 150px !important;
      height: 18px !important;
      overflow: hidden;
      white-space: nowrap;
  }

  .service-point-dropdown ul li {
      overflow: hidden;
      white-space: no wrap;
  }

  .service-point-dropdown ul {
      width: 400px !important;
  }
</style>
